import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/shadcn/breadcrumb.tsx";
import {Link, useLocation, useParams} from "react-router-dom";
import {Icon} from "@/components/Icon.tsx";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {menuItems, MenuItem} from "@/constant/menu-items.ts";
import {chatbotListQuery} from "@/store/chatbot.ts";
import {Chatbot} from "@/models/chatbot.ts";

import './styles.scss'

export default function Breadcrumbs(props: any) {
  const {t} = useTranslation();
  const location = useLocation();

  let {chatbotID} = useParams();

  const [chatbot, setChatbot] = useState<Chatbot>();
  const [chatbotNumber, setChatbotNumber] = useState<number|null>();
  const [chatbotMenuItem, setChatbotMenuItem] = useState<
    MenuItem | undefined
  >();

  const listQuery = chatbotListQuery();

  useEffect(() => {
    if (chatbotID) {
      // Chatbot menu item
      let items = menuItems({chatbotID: chatbotID, userID : null});
      setChatbotMenuItem(
        items.find((item) => {
          if (item && item.link) {
            return item && location.pathname.includes(item.link);
          }
          return false;
        }),
      );
    }
  }, [location.pathname]);

  useEffect(() => {
    if (chatbotID && listQuery.data) {
      setChatbot(
        listQuery.data.find((chatbot: Chatbot) => {
          return chatbot.id === chatbotID;
        }),
      );

      for (let i=0; i < listQuery.data.length; i++) {
        if (chatbotID === listQuery.data[i].id) {
          setChatbotNumber(listQuery.data.length-i)
        }
      }
    }
  }, [listQuery.data, chatbotID]);

  return (
    <>
      <Breadcrumb className="lg:hidden">
        <BreadcrumbList>
          <BreadcrumbItem className="">
            <Link to="/dashboard">
              <BreadcrumbPage>
                <Icon icon="fluent:home-20-regular" width="20"/>
              </BreadcrumbPage>
            </Link>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Breadcrumb className="hidden lg:inline-block">
        <BreadcrumbList>
          <BreadcrumbItem className="">
            <Link to="/dashboard">
              <BreadcrumbPage>
                <Icon icon="fluent:home-20-regular" width="20"/>
              </BreadcrumbPage>
            </Link>
          </BreadcrumbItem>

          {chatbotID && chatbot && (
            <>
              <BreadcrumbSeparator/>
              <BreadcrumbItem>
                <Link to={`/chatbot/${chatbotID}/playground`}>
                  <BreadcrumbPage>{chatbot.settings?.name ? chatbot.settings.name : `${t("sidebar.chabot")} #${chatbotNumber}` }</BreadcrumbPage>
                </Link>
              </BreadcrumbItem>
            </>
          )}

          {chatbotID && chatbotMenuItem && chatbotMenuItem.title && (
            <>
              <BreadcrumbSeparator/>
              <BreadcrumbItem>
                <BreadcrumbPage>{chatbotMenuItem.title}</BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </>

  );
}
